import { render } from "./RSSFeed.vue?vue&type=template&id=2c02dbad&scoped=true"
import script from "./RSSFeed.vue?vue&type=script&lang=js"
export * from "./RSSFeed.vue?vue&type=script&lang=js"

import "./RSSFeed.vue?vue&type=style&index=0&id=2c02dbad&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c02dbad"]])

export default __exports__